var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotvs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0B4C8C",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.385 0 0 5.339 0 12c0 6.614 5.385 12 12 12 6.614 0 12 -5.386 12 -12S18.614 0 12 0ZM8.648 3.813c1.275 -0.068 10.697 2.302 11.43 2.943 0.614 0.85 0.614 9.118 0 9.685 -0.284 0.095 -2.127 -0.283 -4.205 -0.755 0 2.031 -0.143 3.966 -0.426 4.203 -0.756 0.236 -10.772 -2.267 -11.527 -2.928 -0.615 -0.85 -0.615 -9.119 0 -9.686 0.283 -0.094 2.079 0.284 4.205 0.756 0 -2.031 0.142 -3.969 0.425 -4.205a0.448 0.448 0 0 1 0.098 -0.013Zm-0.523 4.265c-0.048 2.362 0.095 4.961 0.425 5.434 0.426 0.378 4.158 1.418 7.276 2.174 0.047 -2.41 -0.095 -5.008 -0.426 -5.481 -0.425 -0.378 -4.157 -1.418 -7.275 -2.127Z",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotvs);
export default __webpack_public_path__ + "static/media/totvs.5ee82e45fa87fe77c610947c10671552.svg";
export { ForwardRef as ReactComponent };